<template>
  <li :class="['detailed-card__item', { '--link': hasLink(content) }]">
    <component
      :is="hasLink(content) ? 'a' : 'div'"
      :href="content.link"
      :target="hasLink(content) ? '_blank' : null"
      class="detailed-card"
    >
      <Image v-if="content.image" :source="content.image" class="detailed-card__image" />
      <div class="detailed-card__content">
        <h3 class="small-title --arrow">
          <span>{{ content.title }}</span>
          <Icon id="arrow" v-if="hasLink(content)" />
        </h3>
        <p>{{ content.description }}</p>
      </div>
    </component>
  </li>
</template>

<script>
import { Icon, Image } from '@/components/global'
import { hasLink } from '@/helpers/hasLink.js'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'DetailedCard',
  mixins: [DefaultSectionProps],
  components: { Icon, Image },
  methods: {
    hasLink,
  },
}
</script>
